/**
 * cctv-web 토큰 저장소.
 *
 * Phase 4 부터 키를 `ontoh.cctv.*` namespace 로 격리 — 같은 도메인에서
 * `ontoh-auth-portal` (`ontoh.auth.*`) 와 분리되어 영향 X.
 *
 * 기존 사용자 세션 (`access_token` / `refresh_token`) 은 첫 import 시
 * 1회 마이그레이션 (있으면 새 키로 옮기고 옛 키 삭제). 이후 호출은 새 키만 사용.
 */

const ACCESS_KEY = 'ontoh.cctv.access';
const REFRESH_KEY = 'ontoh.cctv.refresh';
const LEGACY_ACCESS_KEY = 'access_token';
const LEGACY_REFRESH_KEY = 'refresh_token';

export function isTokenStorageKey(key: string | null): boolean {
  return key === null || key === ACCESS_KEY || key === REFRESH_KEY;
}

(function migrateLegacyKeys(): void {
  try {
    const oldAccess = localStorage.getItem(LEGACY_ACCESS_KEY);
    if (oldAccess && !localStorage.getItem(ACCESS_KEY)) {
      localStorage.setItem(ACCESS_KEY, oldAccess);
    }
    const oldRefresh = localStorage.getItem(LEGACY_REFRESH_KEY);
    if (oldRefresh && !localStorage.getItem(REFRESH_KEY)) {
      localStorage.setItem(REFRESH_KEY, oldRefresh);
    }
    if (oldAccess) localStorage.removeItem(LEGACY_ACCESS_KEY);
    if (oldRefresh) localStorage.removeItem(LEGACY_REFRESH_KEY);
  } catch {
    // SSR / private mode 등 — 그냥 무시
  }
})();

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY);
}

export function setTokens(access: string, refresh: string): void {
  localStorage.setItem(ACCESS_KEY, access);
  localStorage.setItem(REFRESH_KEY, refresh);
}

export function clearTokens(): void {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
